import React from 'react';
import { ResponsiveTokenSet } from '../../theme/tokens/types';

import { ITextOnlyHeroFields } from '../../../types/contentful';

import PictogramComponent from '../AtomicComponents/Pictogram';
import CtaWidget from '../CtaWidget';
import classNames from 'classnames';
import CapsuleBadge from '../AtomicComponents/CapsuleBadge';

interface Props extends ITextOnlyHeroFields {
  yMarginTopOverride?: ResponsiveTokenSet<string>;
  yMarginBottomOverride?: ResponsiveTokenSet<string>;
}

export function TextOnlyHero({
  pictogram,
  capsule,
  headingText,
  heroCopy,
  buttonAnchor,
  buttonColor,
  buttonText,
  ctaWidget,
  yMarginTopOverride,
  yMarginBottomOverride
}: Props) {
  return (
    <section
      className={classNames('block-container', {
        [`mt-${yMarginTopOverride?.[0]}`]: yMarginTopOverride?.[0],
        [`mobile:mt-${yMarginTopOverride?.mobile}`]: yMarginTopOverride?.mobile,
        [`tablet:mt-${yMarginTopOverride?.tablet}`]: yMarginTopOverride?.tablet,
        [`desktop:mt-${yMarginTopOverride?.desktop}`]:
          yMarginTopOverride?.desktop,
        [`mb-${yMarginBottomOverride?.[0]}`]: yMarginBottomOverride?.[0],
        [`mobile:mb-${yMarginBottomOverride?.mobile}`]:
          yMarginBottomOverride?.mobile,
        [`tablet:mb-${yMarginBottomOverride?.tablet}`]:
          yMarginBottomOverride?.tablet,
        [`desktop:mb-${yMarginBottomOverride?.desktop}`]:
          yMarginBottomOverride?.desktop
      })}
      data-blockid="text-only-hero"
      data-testid="text-only-hero"
      data-e2e="hero"
    >
      <div className="mx-auto flex max-w-max flex-col items-center justify-center gap-6 px-6 py-12">
        <div className="mx-auto flex w-full flex-col items-center gap-4 self-stretch desktop:w-8/12">
          {pictogram && <PictogramComponent {...pictogram.fields} />}
          {capsule && <CapsuleBadge {...capsule.fields} />}
          <h1 className="typography-display-1 text-center font-normal">
            {headingText}
          </h1>
        </div>
        {heroCopy && (
          <h3 className="typography-display-4 text-center font-normal">
            {heroCopy}
          </h3>
        )}
        {buttonText && buttonAnchor && (
          <a
            className={classNames(
              'typography-button-md flex min-w-44 max-w-lg shrink-0 flex-col items-center justify-center rounded-button-shape p-4',
              { 'bg-callout': buttonColor === 'registration' },
              {
                'bg-primary text-on-primary-surface-dark':
                  buttonColor === 'primary'
              }
            )}
            type="button"
            href={buttonAnchor}
          >
            {buttonText}
          </a>
        )}
        {ctaWidget && <CtaWidget {...ctaWidget.fields} className="w-full" />}
      </div>
    </section>
  );
}
